import React, { useState, useEffect } from "react";
import { Clock, Phone, Mail, MapPin, FileText } from "lucide-react";
import { company } from "../mock";
import { trackConversion, CONV } from "../lib/gtag";
import LogoMark from "./Logo";

const WaIcon = ({ size = 32 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347M12.05 21.785h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.002-5.45 4.437-9.884 9.889-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.892 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 1.16 5.335 1.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413" />
  </svg>
);

export function TopBanner() {
  return (
    <div className="top-banner">
      <span>🚚 <strong>SPEDIZIONE GRATUITA</strong> in tutta Italia</span>
      <span className="sep">·</span>
      <span>🛡️ <strong>GARANZIA 12-24 MESI</strong></span>
      <span className="sep">·</span>
      <span>↩️ Soddisfatti o rimborsati - Reso 14gg</span>
    </div>
  );
}

export function InfoBar() {
  return (
    <div className="info-bar">
      <div className="info-bar-inner">
        <span className="item"><Clock size={15} /> {company.hours}</span>
        <span className="sep">·</span>
        <a href={`tel:${company.phoneIntl}`}><Phone size={15} /> {company.phoneDisplay}</a>
        <span className="sep">·</span>
        <a href={`mailto:${company.email}`}><Mail size={15} /> {company.email}</a>
      </div>
    </div>
  );
}

export function Navbar({ onQuote }) {
  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <a href="#top" className="logo" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}>
          <LogoMark size={46} />
          <span className="logo-text">
            <span className="logo-name">DEA S.R.L.</span>
            <span className="logo-sub">Motori & Autoricambi</span>
          </span>
        </a>
        <div className="nav-links">
          <a href="#catalogo">Catalogo</a>
          <a href="#contatti">Contatti</a>
        </div>
        <div className="nav-cta">
          <a href={`https://wa.me/${company.wa}`} target="_blank" rel="noreferrer" className="btn btn-whatsapp" onClick={() => trackConversion(CONV.contatto)}>WhatsApp</a>
          <button className="btn btn-cta" onClick={onQuote}>Preventivo</button>
        </div>
      </div>
    </nav>
  );
}

export function Footer() {
  return (
    <>
      <footer className="footer" id="contatti">
        <div className="footer-inner">
          <div>
            <div className="footer-logo">
              <LogoMark size={46} />
              <span className="logo-name" style={{ color: "#fff" }}>DEA S.R.L.</span>
            </div>
            <p>Vendita motori usati, rettificati, revisionati e rigenerati per auto di tutte le marche. 16 anni di esperienza, garanzia 12-24 mesi e spedizione gratuita in tutta Italia.</p>
            <p style={{ marginTop: "1rem", fontSize: "0.82rem", color: "#93a3b5" }}>P.IVA {company.piva}</p>
          </div>
          <div>
            <h4>Contatti</h4>
            <div className="footer-contact-item"><MapPin size={18} /><span>{company.address}</span></div>
            <div className="footer-contact-item"><Phone size={18} /><a href={`tel:${company.phoneIntl}`}>{company.phoneDisplay}</a></div>
            <div className="footer-contact-item"><Mail size={18} /><a href={`mailto:${company.email}`}>{company.email}</a></div>
            <div className="footer-contact-item"><Clock size={18} /><span>{company.hours}</span></div>
          </div>
          <div>
            <h4>Link utili</h4>
            <ul>
              <li><a href="#offerta">Cosa offriamo</a></li>
              <li><a href="#processo">Come acquistare</a></li>
              <li><a href="#marche">Marche trattate</a></li>
              <li><a href="#recensioni">Recensioni clienti</a></li>
              <li><a href={`https://wa.me/${company.wa}`} target="_blank" rel="noreferrer">Richiedi preventivo</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} {company.name} · P.IVA {company.piva} · Tutti i diritti riservati</span>
          <span><FileText size={13} style={{ verticalAlign: "-2px", marginRight: 4 }} />Privacy Policy · Cookie Policy</span>
        </div>
      </footer>
      <div className="footer-condensed">
        <strong>Dal {company.since}</strong><span className="sep">·</span>
        <strong>{company.soldPlus} motori venduti</strong><span className="sep">·</span>
        Garanzia 12-24 mesi<span className="sep">·</span>Spedizione gratuita in tutta Italia
      </div>
    </>
  );
}

export function FloatingWhatsApp() {
  return (
    <a href={`https://wa.me/${company.wa}`} target="_blank" rel="noreferrer" className="whatsapp-float" aria-label="Contattaci su WhatsApp" onClick={() => trackConversion(CONV.contatto)}>
      <WaIcon size={34} />
    </a>
  );
}

export function MobileBar({ onQuote }) {
  return (
    <div className="mobile-bar" aria-label="Contatti rapidi mobile">
      <button className="mobile-call" onClick={onQuote}>
        <FileText size={22} color="#fff" />
        Preventivo
      </button>
      <a className="mobile-wa" href={`https://wa.me/${company.wa}`} target="_blank" rel="noreferrer" onClick={() => trackConversion(CONV.contatto)}>
        <WaIcon size={22} />
        WhatsApp
      </a>
    </div>
  );
}

export function CookieBanner() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => {
      if (!localStorage.getItem("dea_cookie_consent")) setVisible(true);
    }, 1200);
    return () => clearTimeout(t);
  }, []);
  const decide = (v) => { localStorage.setItem("dea_cookie_consent", v); setVisible(false); };
  if (!visible) return null;
  return (
    <div className="cookie-banner" role="dialog" aria-label="Avviso cookie">
      <h3>🍪 Rispetto della tua privacy</h3>
      <p>Usiamo cookie tecnici (necessari) e, con il tuo consenso, cookie statistici e di marketing per migliorare il sito. Puoi accettare tutti o rifiutare. Più info nella <a href="#cookie" onClick={(e) => e.preventDefault()}>Cookie Policy</a>.</p>
      <div className="cookie-buttons">
        <button className="cookie-btn cookie-btn-reject" onClick={() => decide("reject")}>Rifiuta</button>
        <button className="cookie-btn cookie-btn-accept" onClick={() => decide("accept")}>Accetta tutti</button>
      </div>
    </div>
  );
}

export { WaIcon };
